export function isMobileSafari () {
  return false
}
